/**
 * Phase 77b (Feb-2026) — "M" pill that marks any pilot in manual-only
 * allocation mode. Renders nothing for `allocation_mode === "auto"` or
 * when the prop is missing, so it's safe to drop next to any pilot name
 * without a guard.
 *
 *     <PilotName />  <ManualBadge mode={pilot.allocation_mode} />
 */
import React from 'react';

export default function ManualBadge({ mode, className = '' }) {
  if ((mode || 'auto') !== 'manual') return null;
  return (
    <span
      data-testid="pilot-manual-badge"
      title="This pilot is set to manual allocation only — no auto-allocation will go to them"
      className={`inline-flex items-center justify-center text-[9px] uppercase tracking-widest font-bold w-4 h-4 rounded bg-[#FF8C00]/10 text-[#FF8C00] ${className}`}
    >
      M
    </span>
  );
}
